<nav [attr.aria-label]="ariaLabel | translate">
    <ol class="step-nav">
        @for (step of view; track step.id) {
            <li>
                <a
                    class="step-nav__step"
                    [class.is-active]="step.state === 'active'"
                    [class.is-past]="step.state === 'past'"
                    [routerLink]="step.route"
                    [attr.aria-current]="step.state === 'active' ? 'step' : null">
                    <span class="step-nav__badge" aria-hidden="true">
                        @if (step.icon) {
                            <span class="material-symbols-outlined">{{ step.icon }}</span>
                        } @else {
                            <span class="step-nav__number">{{ step.number }}</span>
                        }
                    </span>
                    <span>{{ step.label | translate }}</span>
                </a>
            </li>
        }
    </ol>
</nav>
